import Button, { IconButton } from '@components/shared/Button'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { useLocalStorage } from 'hooks/useLocalStorageState'
import { useState } from 'react'
import { ANNOUNCEMENT, ANNOUNCEMENT_ID_KEY } from 'utils/announcements'
import Modal from '@components/shared/Modal'
import Link from 'next/link'
import RenderMarkdown from './RenderMarkdown'
import { useTranslation } from 'next-i18next'

const TopBanner = () => {
  const { t } = useTranslation('announcements')
  const [announcementClosedId, setAnnouncementClosedId] =
    useLocalStorage(ANNOUNCEMENT_ID_KEY)
  const [showLongDescription, setShowLongDescription] = useState(false)

  const { id, textKey, show, longDescriptionKey, linkPath, external } =
    ANNOUNCEMENT

  return (
    <>
      {show && announcementClosedId !== id ? (
        <div className="flex items-center justify-center overflow-hidden bg-gradient-to-r from-[#FF6B35] via-[#FFA241] to-[#FFD37A] py-2 shadow-[inset_0_-1px_0_rgba(0,0,0,0.18)]">
          <div className="flex w-full items-center justify-between px-4">
            <div className="sm:size-5" />
            <div className="flex items-center gap-2.5">
              <span
                aria-hidden="true"
                className="inline-flex size-2 shrink-0 animate-pulse rounded-full bg-[#01070E]/85 shadow-[0_0_10px_2px_rgba(1,7,14,0.4)]"
              />
              {linkPath ? (
                external ? (
                  <a
                    className="text-sm font-semibold tracking-tight text-[#01070E] underline-offset-4 hover:text-[#111D2C] hover:underline sm:text-[15px]"
                    href={linkPath}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{t(textKey)}</span>
                  </a>
                ) : (
                  <Link
                    className="text-sm font-semibold tracking-tight text-[#01070E] underline-offset-4 hover:text-[#111D2C] hover:underline sm:text-[15px]"
                    href={linkPath}
                  >
                    <span>{t(textKey)}</span>
                  </Link>
                )
              ) : longDescriptionKey ? (
                <button
                  onClick={() => setShowLongDescription(!showLongDescription)}
                  className="default-transition text-center text-sm font-semibold leading-tight tracking-tight text-[#01070E] underline-offset-4 hover:text-[#111D2C] hover:underline sm:text-[15px]"
                >
                  <span>{t(textKey)}</span>
                </button>
              ) : (
                <p className="text-center text-sm font-semibold leading-tight tracking-tight text-[#01070E] sm:text-[15px]">
                  {t(textKey)}
                </p>
              )}
            </div>
            <IconButton
              onClick={() => setAnnouncementClosedId(id)}
              hideBg
              className="ml-4 shrink-0"
            >
              <XMarkIcon className="size-5 text-[#01070E] hover:text-[#111D2C]" />
            </IconButton>
          </div>
        </div>
      ) : null}

      {showLongDescription && longDescriptionKey ? (
        <Modal
          isOpen={showLongDescription}
          onClose={() => setShowLongDescription(false)}
        >
          <RenderMarkdown markdown={t(longDescriptionKey)} />
          <div className="mt-6 flex justify-center">
            <Button
              className="w-full"
              onClick={() => setShowLongDescription(false)}
            >
              {t('lets-go')}
            </Button>
          </div>
        </Modal>
      ) : null}
    </>
  )
}

export default TopBanner
